import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ChatsCircle, ArrowRight, UsersThree } from "@phosphor-icons/react";

export default function FamilyUnreadWidget() {
  const [channels, setChannels] = useState(null);

  useEffect(() => {
    api.get("/chat/channels").then((r) => setChannels(r.data)).catch(() => setChannels(false));
  }, []);

  if (channels === null || channels === false) return null;
  const unreadChans = channels.filter((c) => c.unread > 0);
  const total = unreadChans.reduce((s, c) => s + c.unread, 0);

  return (
    <div className="glass-card p-5 flex flex-col" data-testid="family-unread-widget">
      <div className="flex items-center gap-2 mb-3">
        <ChatsCircle size={18} weight="duotone" className="text-primary" />
        <h2 className="font-heading font-semibold text-sm flex-1">Семейный чат</h2>
        {total > 0 && <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-primary text-white text-[11px] num font-bold flex items-center justify-center" data-testid="family-unread-total">{total}</span>}
      </div>
      {unreadChans.length === 0 ? (
        <p className="text-xs text-muted-foreground flex-1">Нет новых сообщений — всё прочитано.</p>
      ) : (
        <div className="space-y-2 flex-1">
          {unreadChans.slice(0, 4).map((c) => (
            <Link key={c.channel} to="/chat" className="flex items-center gap-2 text-sm hover:bg-secondary/50 rounded-md px-1 py-1 -mx-1 transition-colors" data-testid={`unread-chan-${c.channel}`}>
              <UsersThree size={14} className="text-muted-foreground shrink-0" />
              <span className="flex-1 truncate font-semibold">{c.label}</span>
              <span className="text-xs text-muted-foreground truncate max-w-[40%]">{c.last_text}</span>
              <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-white text-[10px] num font-bold flex items-center justify-center">{c.unread}</span>
            </Link>
          ))}
        </div>
      )}
      <Link to="/chat" className="flex items-center gap-1 text-xs text-primary mt-3 hover:underline" data-testid="family-widget-open-chat">
        Открыть чат <ArrowRight size={12} />
      </Link>
    </div>
  );
}
